// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_KHZ","cls2":"buttonStyles-cls2_G1E buttonStyles-cls1_KHZ"};